import "./News.scss";
// import nimg from "./img/noimage.png";

import nimg1 from "./img/newnow.jpg";
import nimg2 from "./img/chibita.jpg";
import nimg3 from "./img/adikt.jpg";
import nimg4 from "./img/big.jpg";


import Modal from "react-modal";
import { useState } from "react";

const NewscustomStyles = {
  overlay: {

    backgroundColor: "rgba(255, 255, 255, 0.5)"
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    width:"100%",
    // marginRight: "-50%",
    transform: "translate(-50%, -50%)",

  },
};

const News = () => {
  const [editModalIsOpen, setEditModalIsOpen] = useState(false);
  const [newsImage, setNewsImage] = useState("");


const closeModal = () =>{
  setEditModalIsOpen(false);
  document.removeEventListener('click',closeModal)
};

const openModal = (event) =>{
  setEditModalIsOpen(true);
  document.addEventListener('click',closeModal)
  event.stopPropagation()
  console.log(event.target.src)　　
  console.log(event.curretTarget) 
  setNewsImage(event.target.src);
};




    // Modal.setAppElement("#root");

  const newsItem = [
    {
      img: nimg1,
      title: "New Now!!",
      place: "@下北沢THREE",
      date: "7/30(Sun) Open16:30",
      price: "",
      caption: "",
    },
    {
      img: nimg4,
      title: "BIG",
      place: "@Club bar family(渋谷)",
      date: "7/14(Fri) Open22:30",
      price: "Entrance：¥1000",
      caption: "",
    },

    {
      img: nimg2,
      title: "ちびたの住む街",
      place: "マイケルロック168(清瀬)",
      date: "6/24(Sat) Open16:00",
      price: "door:¥1000+1D",
      caption: "",
    },
    {
      img: nimg3,
      title: "ADIKT",
      place: "Dining Bar Sir Lie underground",
      date: "4/18(Sun) Open15:00",
      price: "Entrance:¥1000",
      caption: "",
    }
    
  ];

  return (
    <div className="News-container-main">
      <div className="News-title">
        <h2 id="Live" className="index">
          Live
        </h2>
      </div>
      <div className="News-wrapper">
        <div className="News-item">
          <ul>
            {newsItem.map((newsItem) => (
              <li>
                
                <button onClick={(event)=>{openModal(event)}}>
                <img src={newsItem.img} alt="" />
                </button>
                {editModalIsOpen? <Modal onClick={()=>{closeModal()}}/> :""}
                <div className="News-item-caption">
                <p>{newsItem.date}</p>
                <p>{newsItem.title}</p>
                <p>{newsItem.place}</p>
                <p>{newsItem.price}</p>
                </div>
              </li>
            
            ))}
          </ul>

          <Modal isOpen={editModalIsOpen} style={NewscustomStyles}>
            <div className="Modal-img">
        <img className="News-modal-img"  src={newsImage} alt="" />
        </div>
      </Modal>
        </div>
      </div>
    </div>
  );
};

export default News;
